module.exports = __webpack_public_path__ + "static/media/Damage.7a8ecc6b.jpg";